import { render } from "./PageNewsItem.vue?vue&type=template&id=63df3452"
import script from "./PageNewsItem.vue?vue&type=script&lang=js"
export * from "./PageNewsItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__